import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Notice the loneliness",
    opening: localizedGenderNode(
      [
      "Today I don't try to fill it.",
      "I just notice the loneliness when it is here.",
      "That is enough for now."
    ],
      [
      "Today I don't try to fill it.",
      "I just notice the loneliness when it is here.",
      "That is enough for now."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When is the loneliness most felt?",
      "What is happening around me then?",
      "How does the loneliness feel in my body?"
    ],
      [
      "When is the loneliness most felt?",
      "What is happening around me then?",
      "How does the loneliness feel in my body?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Noticing loneliness is already a gentle connection."
    ],
      [
      "Noticing loneliness is already a gentle connection."
    ]
    ),
    action: localizedGenderNode(
      "one breath with the words \"I am here\".",
      "one breath with the words \"I am here\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "What is missing there",
    opening: localizedGenderNode(
      [
      "Today I ask what I miss inside the people around me.",
      "Without blame.",
      "Just to see."
    ],
      [
      "Today I ask what I miss inside the people around me.",
      "Without blame.",
      "Just to see."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my chest."
    ],
      [
      "I breathe slowly.",
      "I feel my chest."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I miss in my connection with people around me?",
      "What would I want them to see in me?",
      "What is hard for me to ask for?"
    ],
      [
      "What do I miss in my connection with people around me?",
      "What would I want them to see in me?",
      "What is hard for me to ask for?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Sometimes a small lack explains a lot."
    ],
      [
      "Sometimes a small lack explains a lot."
    ]
    ),
    action: localizedGenderNode(
      "write one word about what is missing.",
      "write one word about what is missing."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "The moment I pull away",
    opening: localizedGenderNode(
      [
      "Today I notice the moment I pull away.",
      "Without judging.",
      "Just to see."
    ],
      [
      "Today I notice the moment I pull away.",
      "Without judging.",
      "Just to see."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When do I close off around people?",
      "What triggers that in me?",
      "What am I trying to protect?"
    ],
      [
      "When do I close off around people?",
      "What triggers that in me?",
      "What am I trying to protect?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Even closing off is an attempt to protect."
    ],
      [
      "Even closing off is an attempt to protect."
    ]
    ),
    action: localizedGenderNode(
      "tell myself \"I understand\".",
      "tell myself \"I understand\"."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Presence without a mask",
    opening: localizedGenderNode(
      [
      "Today I check what it is like to be for a moment without a mask.",
      "Not much.",
      "Just a little."
    ],
      [
      "Today I check what it is like to be for a moment without a mask.",
      "Not much.",
      "Just a little."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my face."
    ],
      [
      "I breathe slowly.",
      "I feel my face."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I usually hide?",
      "What am I afraid they will see?",
      "Where can I release 1%?"
    ],
      [
      "What do I usually hide?",
      "What am I afraid they will see?",
      "Where can I release 1%?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small moment of truth warms the heart."
    ],
      [
      "A small moment of truth warms the heart."
    ]
    ),
    action: localizedGenderNode(
      "one true sentence to myself.",
      "one true sentence to myself."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "The pattern that keeps me alone",
    opening: localizedGenderNode(
      [
      "Today I see a small pattern that distances me.",
      "Without blame.",
      "Just light."
    ],
      [
      "Today I see a small pattern that distances me.",
      "Without blame.",
      "Just light."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "I feel my belly."
    ],
      [
      "I pause for a moment.",
      "I feel my belly."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What pattern repeats when I am with people?",
      "How does it protect me?",
      "What is its cost for me?"
    ],
      [
      "What pattern repeats when I am with people?",
      "How does it protect me?",
      "What is its cost for me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A protective pattern can also hurt."
    ],
      [
      "A protective pattern can also hurt."
    ]
    ),
    action: localizedGenderNode(
      "name one pattern.",
      "name one pattern."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "The need underneath",
    opening: localizedGenderNode(
      [
      "Today I look for the need beneath the loneliness.",
      "Not a solution.",
      "Just a need."
    ],
      [
      "Today I look for the need beneath the loneliness.",
      "Not a solution.",
      "Just a need."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe.",
      "I am here."
    ],
      [
      "I breathe.",
      "I am here."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I truly need here?",
      "What would I want to receive?",
      "What can I give myself now?"
    ],
      [
      "What do I truly need here?",
      "What would I want to receive?",
      "What can I give myself now?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One clear need softens the heart."
    ],
      [
      "One clear need softens the heart."
    ]
    ),
    action: localizedGenderNode(
      "write one need in a word.",
      "write one need in a word."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "A small moment of connection",
    opening: localizedGenderNode(
      [
      "Today I look for a small moment of connection.",
      "Not big.",
      "Small is enough."
    ],
      [
      "Today I look for a small moment of connection.",
      "Not big.",
      "Small is enough."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "I feel my breath."
    ],
      [
      "I pause for a moment.",
      "I feel my breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When did I have a small connection recently?",
      "What allowed me to feel it?",
      "What small step could invite more?"
    ],
      [
      "When did I have a small connection recently?",
      "What allowed me to feel it?",
      "What small step could invite more?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Even a small connection changes the day."
    ],
      [
      "Even a small connection changes the day."
    ]
    ),
    action: localizedGenderNode(
      "remember one such moment.",
      "remember one such moment."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "A boundary that protects connection",
    opening: localizedGenderNode(
      [
      "Today I see a boundary that protects me around people.",
      "Without distancing.",
      "Just to protect."
    ],
      [
      "Today I see a boundary that protects me around people.",
      "Without distancing.",
      "Just to protect."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my shoulders."
    ],
      [
      "I breathe slowly.",
      "I feel my shoulders."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where do I give too much in relationships?",
      "What small boundary could help?",
      "How do I say it to myself?"
    ],
      [
      "Where do I give too much in relationships?",
      "What small boundary could help?",
      "How do I say it to myself?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small boundary keeps presence."
    ],
      [
      "A small boundary keeps presence."
    ]
    ),
    action: localizedGenderNode(
      "one boundary sentence to myself.",
      "one boundary sentence to myself."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Staying one more moment",
    opening: localizedGenderNode(
      [
      "Today I practice staying one more moment.",
      "Not disappearing too fast.",
      "Just a moment."
    ],
      [
      "Today I practice staying one more moment.",
      "Not disappearing too fast.",
      "Just a moment."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When do I leave too fast?",
      "What scares me if I stay?",
      "What happens if I stay 10 more seconds?"
    ],
      [
      "When do I leave too fast?",
      "What scares me if I stay?",
      "What happens if I stay 10 more seconds?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One more moment can be a change."
    ],
      [
      "One more moment can be a change."
    ]
    ),
    action: localizedGenderNode(
      "pause 10 seconds before I disappear.",
      "pause 10 seconds before I disappear."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "One clear request",
    opening: localizedGenderNode(
      [
      "Today I form one request toward myself.",
      "Not to demand.",
      "Just to acknowledge."
    ],
      [
      "Today I form one request toward myself.",
      "Not to demand.",
      "Just to acknowledge."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe.",
      "I am here."
    ],
      [
      "I breathe.",
      "I am here."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is one request I would like to bring?",
      "How can I say it gently?",
      "What small step can I take?"
    ],
      [
      "What is one request I would like to bring?",
      "How can I say it gently?",
      "What small step can I take?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One request can open a door to connection."
    ],
      [
      "One request can open a door to connection."
    ]
    ),
    action: localizedGenderNode(
      "write the request in one sentence.",
      "write the request in one sentence."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "One gaze that holds",
    opening: localizedGenderNode(
      [
      "Today I look for one gaze that holds me.",
      "Even an inner gaze.",
      "Enough."
    ],
      [
      "Today I look for one gaze that holds me.",
      "Even an inner gaze.",
      "Enough."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "I feel my eyes."
    ],
      [
      "I pause for a moment.",
      "I feel my eyes."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Who or what gives me a sense of being seen?",
      "How does it feel when someone truly sees me?",
      "How can I give that to myself?"
    ],
      [
      "Who or what gives me a sense of being seen?",
      "How does it feel when someone truly sees me?",
      "How can I give that to myself?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A gentle gaze can open space."
    ],
      [
      "A gentle gaze can open space."
    ]
    ),
    action: localizedGenderNode(
      "look at myself in the mirror gently for a moment.",
      "look at myself in the mirror gently for a moment."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "A quiet voice inside",
    opening: localizedGenderNode(
      [
      "Today I listen to the quiet voice inside me.",
      "Even if it is small.",
      "It is there."
    ],
      [
      "Today I listen to the quiet voice inside me.",
      "Even if it is small.",
      "It is there."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I make room for it."
    ],
      [
      "I breathe slowly.",
      "I make room for it."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What does the quiet voice tell me now?",
      "What is it asking of me?",
      "How does it feel to listen to it?"
    ],
      [
      "What does the quiet voice tell me now?",
      "What is it asking of me?",
      "How does it feel to listen to it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A quiet voice can return me to myself."
    ],
      [
      "A quiet voice can return me to myself."
    ]
    ),
    action: localizedGenderNode(
      "one sentence from the quiet voice.",
      "one sentence from the quiet voice."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "A small choice toward connection",
    opening: localizedGenderNode(
      [
      "Today I choose a small step toward connection.",
      "No drama.",
      "A small step."
    ],
      [
      "Today I choose a small step toward connection.",
      "No drama.",
      "A small step."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small step am I willing to try?",
      "What scares me about this step?",
      "How will it protect me?"
    ],
      [
      "What small step am I willing to try?",
      "What scares me about this step?",
      "How will it protect me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small step can shift the pace."
    ],
      [
      "A small step can shift the pace."
    ]
    ),
    action: localizedGenderNode(
      "choose one small step and remember it.",
      "choose one small step and remember it."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Return sentence",
    opening: localizedGenderNode(
      [
      "Today I choose a sentence that brings me back to connection.",
      "When I close off.",
      "A small sentence."
    ],
      [
      "Today I choose a sentence that brings me back to connection.",
      "When I close off.",
      "A small sentence."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe.",
      "I am here."
    ],
      [
      "I breathe.",
      "I am here."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I learn about this loneliness?",
      "What is the first sign it returns?",
      "Which sentence brings me back a moment before?"
    ],
      [
      "What did I learn about this loneliness?",
      "What is the first sign it returns?",
      "Which sentence brings me back a moment before?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I can feel alone and still stay with myself."
    ],
      [
      "I can feel alone and still stay with myself."
    ]
    ),
    action: localizedGenderNode(
      "say the new sentence once.",
      "say the new sentence once."
    ),
  },
].map(buildNormalizedDay);

export const lonelinessEvenWhenThereArePeopleAroundBlueprintEn = buildNormalizedPilotBlueprint({
  id: "loneliness_even_when_there_are_people_around_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "loneliness_even_when_there_are_people_around",
  category: "loneliness_belonging",
  journeyName: {
    he: "בדידות גם כשיש אנשים מסביב",
    en: "Loneliness even when there are people around",
    es: "Soledad incluso cuando hay gente alrededor",
  },
  days,
});

export default lonelinessEvenWhenThereArePeopleAroundBlueprintEn;
